import { render, staticRenderFns } from "./sysuser_list.vue?vue&type=template&id=37f55db4&scoped=true"
import script from "./sysuser_list.vue?vue&type=script&lang=js"
export * from "./sysuser_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f55db4",
  null
  
)

export default component.exports